"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLLayerContext = exports.OLLayerProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Vector_1 = __importDefault(require("ol/layer/Vector"));
const VectorImage_1 = __importDefault(require("ol/layer/VectorImage"));
const Vector_2 = __importDefault(require("ol/source/Vector"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLLayerProvider({ children }) {
    const layerDict = react_1.useRef({});
    const map = useOLMap_1.useOLMap();
    const addFeature = react_1.useCallback((specification, feature) => {
        const hash = getSpecificationHash(specification);
        const existingLayer = layerDict.current[hash];
        if (existingLayer) {
            existingLayer.source.addFeature(feature);
        }
        else {
            const source = new Vector_2.default();
            const layer = specification.renderMode === 'image'
                ? new VectorImage_1.default(Object.assign(Object.assign({}, specification), { source }))
                : new Vector_1.default(Object.assign(Object.assign({}, specification), { source }));
            map.addLayer(layer);
            layerDict.current[hash] = {
                layer,
                source,
                usedBy: [],
            };
            source.addFeature(feature);
        }
    }, [map]);
    const removeFeature = react_1.useCallback((specification, feature) => {
        const hash = getSpecificationHash(specification);
        const layer = layerDict.current[hash];
        if (!layer) {
            console.error('No layer to remove.');
            return;
        }
        layer.source.removeFeature(feature);
    }, []);
    const value = react_1.useMemo(() => ({ addFeature, removeFeature }), [addFeature, removeFeature]);
    return jsx_runtime_1.jsx(exports.OLLayerContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.OLLayerProvider = OLLayerProvider;
exports.OLLayerContext = react_1.createContext({
    addFeature: (_specification, _feature) => { },
    removeFeature: (_specification, _feature) => { },
});
function getSpecificationHash({ zIndex, opacity, renderMode, declutter }) {
    return `z:${zIndex};o:${opacity};m:${renderMode};d:${declutter ? 1 : 0}`;
}
//# sourceMappingURL=OLLayerProvider.js.map